import { render, staticRenderFns } from "./RelatedDocForm.vue?vue&type=template&id=43aef6cc"
import script from "./RelatedDocForm.vue?vue&type=script&lang=ts"
export * from "./RelatedDocForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports